import type { OptionsDocument } from 'paintscout'
import type { UpdateableProduct } from '../..'
import { getProductOption } from '../../../../options/get-product-options/get-product-option'

export default function convertProductDetails({
  productDetails,
  options,
  rateType
}: {
  productDetails: { productKey: string; unitLabel?: string; coverage?: number }
  options: OptionsDocument
  rateType: string
}): UpdateableProduct {
  let legacyDefaultProduct: UpdateableProduct = null
  const productOption = getProductOption({ options, key: productDetails.productKey })
  if (productOption) {
    let coverage = productOption.coverage_rate
    let lnftCoverage = productOption.lnft_coverage
    let quantityCoverage = productOption.quantity_coverage

    if (productDetails.coverage) {
      if (rateType === 'quantity') {
        quantityCoverage = productDetails.coverage
      } else if (rateType === 'lnft') {
        lnftCoverage = productDetails.coverage
      } else {
        coverage = productDetails.coverage
      }
    }

    legacyDefaultProduct = {
      ...productOption,
      color: '',
      volume: { default: 0, custom: 0, useCustom: false },
      coverage: { default: coverage, custom: 0, useCustom: false },
      lnftCoverage: { default: lnftCoverage, custom: 0, useCustom: false },
      quantityCoverage: { default: quantityCoverage, custom: 0, useCustom: false },
      price: { default: productOption.price, custom: 0, useCustom: false },
      totalPrice: { default: 0, custom: 0, useCustom: false }
    }
  }
  return legacyDefaultProduct
}
